import { render, staticRenderFns } from "./AppSAPBadge.vue?vue&type=template&id=c0046f4a&scoped=true&"
import script from "./AppSAPBadge.vue?vue&type=script&lang=js&"
export * from "./AppSAPBadge.vue?vue&type=script&lang=js&"
import style0 from "./AppSAPBadge.vue?vue&type=style&index=0&id=c0046f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0046f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
